<template>
  <div>
    <Header />

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="py-10">
      <div class="container px-6 mx-auto max-w-[1200px] flex flex-col gap-10">
        <div>
          <form
            ref="addCourseRef"
            class="rounded-3xl pt-10 px-6 md:px-10 pb-2 heightfix overflow-y-auto"
            style="box-shadow: 0px 2px 20px 0px #105c8e26"
            @submit.prevent="createCourse"
          >
            <div class="flex items-center justify-between flex-wrap">
              <h1
                class="py-2 text-xl text-center font-bold text-blues w-full md:w-auto"
              >
                Assign Student
              </h1>

              <router-link
                :to="{ name: 'InstructorHome' }"
                class="bg-blues text-white rounded-lg text-sm font-semibold px-3 py-1"
                >Back</router-link
              >
            </div>

            <div class="py-10 flex flex-col gap-6">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <!-- <div class="flex flex-col gap-3">
                      <label for="title" class="text-sm">Title <span class="text-red-400">*</span></label>
                      <input id="title" type="text" required
                        class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none" />
                    </div> -->
                <div class="flex flex-col gap-3">
                  <label for="batch_year" class="text-sm"
                    >Batch Year <span class="text-red-400">*</span></label
                  >
                  <select
                    id="batch_year"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                    <option value="" selected disabled>Select Batch</option>
                    <option
                      v-for="batch_year in batch_years"
                      :key="batch_year.year"
                      :value="batch_year.id"
                    >
                      {{ batch_year.year }}
                    </option>
                  </select>
                </div>
                <div class="flex flex-col gap-3">
                  <label for="program_name" class="text-sm flex gap-2"
                    >Program Name <span class="text-red-400">*</span>
                    <font-awesome-icon
                      @click="isPrograms = true"
                      class="text-base text-green-500 self-end mb-1 h-4 w-4 cursor-pointer hover:text-green-800"
                      :icon="['fas', 'plus']"
                      title="Add Category"
                    />
                  </label>
                  <select
                    id="program_name"
                    required
                    @change="getProgramsFilter()"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                    <option value="" selected disabled>Select Programs</option>
                    <option
                      v-for="program in programs"
                      :key="program.id"
                      :value="program.name"
                    >
                      {{ program.name }}
                    </option>
                  </select>
                </div>
                <div class="flex flex-col gap-3">
                  <label for="department" class="text-sm flex gap-2"
                    >Departments <span class="text-red-400">*</span>

                    <font-awesome-icon
                      @click="isDepartment = true"
                      class="text-base text-green-500 self-end mb-1 h-4 w-4 cursor-pointer hover:text-green-800"
                      :icon="['fas', 'plus']"
                      title="Add Category"
                    />
                  </label>
                  <select
                    id="department"
                    @change="getInstructorListByFilter(), getSemesterFilter()"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                    <option value="" selected disabled>
                      Select Department
                    </option>
                    <option
                      v-for="department in departments"
                      :key="department.id"
                      :value="department.id"
                    >
                      {{ department.name }}
                    </option>
                  </select>
                </div>
                <div class="flex flex-col gap-3">
                  <label for="semester" class="text-sm"
                    >Semester<span class="text-red-400">*</span></label
                  >
                  <select
                    id="semester"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                    <!-- <option v-for="program in programs" :key="program.id" :value="program.name">
                          {{ category.name }}
                        </option> -->
                    <option value="" selected disabled>Select Semester</option>
                    
                    <option v-for="semetser in semetser_list" :key="semetser" :value="semetser.id">{{ semetser.semester }}</option>

                    <!-- <option value="I">I</option>
                    <option value="II">II</option>
                    <option value="III">III</option>
                    <option value="IV">IV</option>
                    <option value="V">V</option>
                    <option value="VI">VI</option> -->
                    <!-- ('I', 'I'),
                        ('II', 'II'),
                        ('III', 'III'),
                        ('IV', 'IV'),
                        ('V', 'V'),
                        ('VI', 'VI'), -->
                  </select>
                </div>
              </div>

              <div class="flex gap-3 flex-wrap">
                <button
                  type="submit"
                  class="text-greens border border-greens rounded-lg text-lg font-semibold px-6 py-1.5"
                >
                  Assign
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import FlashMessage from "@/components/FlashMessage.vue";

export default {
  components: {
    Header,
    FlashMessage,
  },

  data() {
    return {
      categories: null,
      info: null,
      msgverify: "",
      messages: {
        text: "",
        type: "null",
      },
      is_CategoryPopup: false,
      description: "<h4>Write your course content</h4>",
      batch_years: [],
      programs: [],
      departments: [],
      isDepartment: false,
      isPrograms: false,
      instructor_lists: [],
      semetser_list: []
    };
  },

  computed: mapGetters(["userInfo"]),

  async created() {
    // this.getDepartments();
    this.getPrograms();

    axios
      .get(
        `${process.env.VUE_APP_API}/batch-list/?Key=${this.userInfo.token_key}`
      )
      .then((res) => {
        this.batch_years = res.data.data;
      });

    axios
      .get(`${process.env.VUE_APP_API}/category/?format=json`)
      .then((res) => {
        this.categories = res.data.data;
      });
  },

  methods: {
    getInstructorListByFilter() {
      let department_name = document.getElementById("department").value;

      axios
        .get(
          `${process.env.VUE_APP_API}/instructor_all/?Key=${this.userInfo.token_key}&department__name=${department_name}`
        )
        .then((res) => {
          console.log(res);
          this.instructor_lists = res.data.products;
        });
    },

    getProgramsFilter() {
      let program_name = document.getElementById("program_name").value;

      axios
        .get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}&program__name=${program_name}`
        )
        .then((res) => {
          this.departments = res.data.data;
        });
    },

    getSemesterFilter() {
      let batch_year = 1;
      let department_id = document.getElementById("department").value;
      // console.log(index);
      axios
        .get(
          `${process.env.VUE_APP_API}/semetser-get/?Key=${this.userInfo.token_key}&department__id=${department_id}&batch__id=${batch_year}`
        )
        .then((res) => {
          // this.semetser_list = res.data.data;
          this.semetser_list = res.data.data;
        });
    },

    AddPrograms(el) {
      let bodyVal = {
        name: el.target.elements.name.value,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/program_create/?Key=${this.userInfo.token_key}`,
          bodyVal
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: "Program Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.isPrograms = false;
              this.getPrograms();
              this.$refs.addProgramsRef.reset();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },

    getPrograms() {
      axios
        .get(
          `${process.env.VUE_APP_API}/program-list/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.programs = res.data.data;
        });
    },

    getDepartments() {
      axios
        .get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.departments = res.data.data;
        });
    },

    categoryget() {
      axios
        .get(`${process.env.VUE_APP_API}/category/?format=json`)
        .then((res) => {
          this.categories = res.data.data;
        });
    },

    AddDepartment(el) {
      let bodyVal = {
        name: el.target.elements.name.value,
        program: el.target.elements.program_name.value,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/department_create/?Key=${this.userInfo.token_key}`,
          bodyVal
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: "Department Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.isDepartment = false;
              this.getDepartments();
              this.$refs.addDepartment.reset();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },

    async createCourse(e) {
      let token = this.userInfo.token_key;
      let urls = `${process.env.VUE_APP_API}/assign-student-permission/semester/?Key=${token}`;
      let HeaderVal = new FormData();

      HeaderVal.append("batch", e.target.elements.batch_year.value);
      //   HeaderVal.append("program_name", e.target.elements.program_name.value);
      HeaderVal.append("department", e.target.elements.department.value);
      HeaderVal.append("semester", e.target.elements.semester.value);

      await axios.post(urls, HeaderVal).then((response) => {
        console.log(response);
        if (response.data.status == 200) {
          this.messages = {
            text: "Student Assigned successfully",
            type: "success",
          };
          setTimeout(() => {
            this.messages = {
              text: "",
              type: "null",
            };
            this.$refs.addCourseRef.reset();
            this.$router.push({
              name: "instructorCoursesNew",
            });
          }, 1500);
        } else {
          this.messages = {
            text: " Event Faild",
            type: "error",
          };
          setTimeout(() => {
            this.messages = {
              text: "",
              type: "null",
            };
          }, 2000);
        }
      });
    },
  },
};
</script>

<style scoped></style>
